import {
  MelcoModelsPermissionsSubListItem,
  MelcoModelsUserProductPermissions,
  RolesPermissionsApi,
  useAPIQuery,
  useUserToken,
} from "melco-shared-logic";
interface childRolesData {
  [key: string]: Array<MelcoModelsPermissionsSubListItem>;
}

export type TransformedBasicRoles = {
  product_parent_roles?: Array<MelcoModelsPermissionsSubListItem> | null;
  product_child_roles?: childRolesData | null;
  responseObj?: MelcoModelsUserProductPermissions;
};

const transformRoles = (
  response: MelcoModelsUserProductPermissions
): TransformedBasicRoles => {
  const { user_product_access } = response;

  let list = user_product_access ? user_product_access[0].permissions : [];
  const product_parent_roles = list?.filter(
    (option) => option.parent_code === ""
  );

  let product_child_roles: childRolesData = {};

  product_parent_roles?.map((role) => {
    let withFilterArrayData = list?.filter((obj) => {
      return obj.parent_code === role.code && obj.filter_type !== "";
    });

    let arrayData = list?.filter((obj) => {
      return obj.parent_code === role.code && obj.filter_type === "";
    });

    if (role && role.code && role.code != "")
      product_child_roles[role.code] = [
        ...(arrayData ?? []),
        ...(withFilterArrayData ?? []),
      ];
  });
  return {
    ...response,
    responseObj: response,
    product_parent_roles,
    product_child_roles,
  };
};

export const useUserAccountGetPermission = (
  userId?: string,
  productCode?: string
) => {
  const token = useUserToken();

  //const baseApiConfig = useBaseAPIConfig();
  const query = useAPIQuery(
    RolesPermissionsApi,
    ["userAccountGetPermission", userId],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));
      let response;
      response = await api.userAccountGetPermission({ userId: userId ?? "" });

      return { productRoles: transformRoles(response) };
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );

  return {
    ...query,
  };
};
